<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/22gHJy/tc-custom/9781504013321.jpg?1703709018460" alt="This image is the cover for the book Secret Window"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret Window
      </h1>
      <p class="bookDescription body article font2">
        <b>Meg’s dreams seem to predict the future—but can she make a better future for herself? “Filled with sensitivity and warmth” (<i>Children’s Book Review Service</i>).</b><br/><br/> “It was crazy to have dreams that came true. If you talked about them, it’d upset the people you loved and make them angry. Meg had learned something bad about herself, an ugly secret.” And so she decided to keep the dreams to herself, writing them down in a special notebook. Sometimes her dreams were pleasant, but other times they were disturbing—especially the one about the cave with the blue light.<br/>  <br/> When Meg’s worst dreams begin to come true, she’s convinced they bring bad luck. Why else would her father move out to “find himself” or her best friend desert her for a rowdy crowd of older kids? Meg’s grandmother and a wonderful new neighbor finally help her realize that her “secret window” into the future can bring good luck, if understood properly.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Betty Ren Wright
      </h2>
      
      <p class="authorDescription body article">Betty Ren Wright (1927&ndash;2013) was the distinguished author of numerous books for young readers. Her thrillers, including&#160;<I>The Dollhouse Murders, Christina&rsquo;s Ghost,</I>&#160;and&#160;<I>Crandall&rsquo;s Castle</I>, have each won numerous state awards. In addition to her middle-grade mysteries, Wright has also penned more than thirty-five picture books for children, including&#160;<I>The Blizzard</I>, which appeared on state-award master lists and was named a Bank Street Best Children&rsquo;s Book of the Year. In 2006 she was honored as a Notable Wisconsin Children&rsquo;s Author by the Wisconsin Library Association.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?704e967d